module.exports = __webpack_public_path__ + "static/media/fullsizeoutput_2d6c.593f4e00.jpeg";